// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"List_wrapper__SWlOL","placeholder":"List_placeholder__3OrbJ","placeholder-item":"List_placeholder-item__1e1K6"};